import { h, Fragment } from "preact";
import ProductCardPrice from "../helpers/product-list/product-card-price";
import { ArrowRight } from "../helpers/icons";

const LOW_STOCK_LIMIT = 5;

export default function ShoppableImageProduct({ product }) {
  const variant = product.variants[0];
  const image = product.media[0];

  const { quantityAvailable } = variant;

  return (
    <a href={product.onlineStoreUrl} className="shoppable-image__product">
      {image ? (
        <img
          className="styled-article-image shoppable-image__product-image"
          src={window.getSizedImageUrl(image.previewImage.originalSrc, "160x")}
          alt={image.alt || product.title}
        />
      ) : (
        <div className="shoppable-image__product-image"></div>
      )}
      <div className="shoppable-image__product-details">
        <div className="shoppable-image__product-title">{product.title}</div>
        <div className="shoppable-image__product-price">
          <ProductCardPrice
            product={product}
            variant={variant}
            prefix="shoppable-image"
          />
          {quantityAvailable < LOW_STOCK_LIMIT && (
            <div className="shoppable-image__product-availability">{`Only ${quantityAvailable} left`}</div>
          )}
        </div>
      </div>
      <div className="shoppable-image__cta">
        <ArrowRight />
      </div>
    </a>
  );
}
